import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import { Reveal } from "@/components/Reveal";
import { PRIVACY } from "@/data/legal";

export default function PrivacyPage() {
  const { lang } = useI18n();
  const note = PRIVACY.langNote[lang] || "";
  return (
    <section className="pt-36 pb-24 bg-[#FAF9F6]">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <h1 data-testid="privacy-title" className="font-display text-4xl md:text-5xl text-[#1A1A1A] tracking-tight">
            {PRIVACY.title[lang] || PRIVACY.title.it}
          </h1>
          <p className="mt-3 text-sm text-[#5C5C5C]">{PRIVACY.updated[lang] || PRIVACY.updated.it}</p>
          {note && <p className="mt-4 text-sm italic text-[#5C5C5C] bg-white border border-black/5 rounded-xl p-4">{note}</p>}
        </Reveal>
        <div className="mt-10 space-y-8">
          {PRIVACY.sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 30, 180)}>
              <div>
                <h2 className="font-display text-xl md:text-2xl text-[#1D3557] mb-3">{s.h}</h2>
                {s.p.map((para, k) => (
                  <p key={k} className="text-[#5C5C5C] leading-relaxed mb-3 text-[15px]">{para}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
